import "./style.scss";
import { tasksHeaderSelectConst } from "@/src/constants/tasksConsts";
import BtnDefault from "../../BtnDefault/BtnDefault";
import Refresh from "@/src/svg/header/Refresh";
import Archiv from "@/src/svg/header/Archiv";
import AddNew from "@/src/svg/header/AddNew";
import { setActualOfficeTable, setFilterStatus } from "@/src/store/slices/TasksPage/tasksFiltersSlice";
import { useDispatch, useSelector } from "react-redux";
import VerticalLine from "../../VerticalLine/VerticalLine";
import { RootState } from "@/src/store";

const HeaderTasks = () => {
  const dispatch = useDispatch();
  const actualOfficeTable = useSelector((state: RootState) => state.tasksFilters.actualOfficeTable);

  const handleOfficeClick = (officeId: string) => {
    dispatch(setActualOfficeTable(officeId));
    dispatch(setFilterStatus("All"));
  };

  const handleEventRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="header-tasks">
      <div className="header-tasks-offices" role="group" aria-label="Office">
        {tasksHeaderSelectConst.map((item: { id: string; title: string }) => (
          <button
            key={item.id}
            type="button"
            className={`header-tasks-office-pill ${actualOfficeTable === item.id ? "active" : ""}`}
            onClick={() => handleOfficeClick(item.id)}
          >
            {item.title}
          </button>
        ))}
      </div>
      <div className="header-bottom-buttons">
        <BtnDefault onClick={handleEventRefresh}>
          <p>Refresh</p>
          <Refresh />
        </BtnDefault>
        <BtnDefault>
          <p>Archiv</p>
          <Archiv />
        </BtnDefault>
        <VerticalLine />
        <BtnDefault
          reverse={true}
          onClick={() => {
            const current = localStorage.getItem("tasksPageCreate");
            if (current === "show") {
              localStorage.removeItem("tasksPageCreate");
            } else {
              localStorage.setItem("tasksPageCreate", "show");
            }
            window.dispatchEvent(new Event("tasksPageCreateChanged"));
          }}
        >
          <p>Create Task</p>
          <AddNew />
        </BtnDefault>
      </div>
    </div>
  );
};

export default HeaderTasks;
